import { useContext } from 'react';
import { createNamedContext } from '~/util';

export const SearchHistoryContext = createNamedContext('SearchHistoryContext');

export const useSearchHistory = () => useContext(SearchHistoryContext);